import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  actionBtnAltText: {
    id: 'course-authoring.studio-home.courses.import-filter.alt.text',
    defaultMessage: 'Filter settings',
    description: 'Alt text for settings icon to filter course list in course import in library.',
  },
  modalTitle: {
    id: 'course-authoring.studio-home.courses.import-filter.modal.title',
    defaultMessage: 'Show Imported Courses',
    description: 'Title text of modal that allows users to see previously imported courses.',
  },
  checkboxLabel: {
    id: 'course-authoring.studio-home.courses.import-filter.checkbox.label',
    defaultMessage: 'Show Previously Imported Courses',
    description: 'Label text of checkbox that allows users to see previously imported courses.',
  },
  cancelBtn: {
    id: 'course-authoring.studio-home.courses.import-filter.cancelBtn.text',
    defaultMessage: 'Cancel',
    description: 'Cancel button text of modal that allows users to see previously imported courses.',
  },
  saveBtn: {
    id: 'course-authoring.studio-home.courses.import-filter.saveBtn.text',
    defaultMessage: 'Save',
    description: 'Save button text of modal that allows users to see previously imported courses.',
  },
});

export default messages;
